import { addonLifecycle } from 'src/chemkit';
import {
  CHEMKIT_AUTOSAVE_CONFIG_WINDOW_KEY,
  CHEMKIT_AUTOSAVE_RUNTIME_WINDOW_KEY,
} from '@chemkit/contracts/integration/autosave';
import {
  CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY,
  CHEMKIT_UI_TABS_REFRESH_SOURCE,
} from '@chemkit/contracts/integration/dashboard';

// Build-time env flags
export const CHEMKIT_DASHBOARD_ENABLED_ENV = process.env.CHEMKIT_DASHBOARD_ENABLED;

export function parseBooleanFlag(value, fallback = false) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value !== 'string') {
    return fallback;
  }
  const normalized = value.trim().toLowerCase();
  if (normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on') {
    return true;
  }
  if (normalized === '0' || normalized === 'false' || normalized === 'no' || normalized === 'off') {
    return false;
  }
  return fallback;
}

// Runtime constants
export const CHEMKIT_HOST_INFLIGHT_MS = 2000;

// Window key names
export const WINDOW_KEY_DASHBOARD_CONFIG = CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY;
export const WINDOW_KEY_AUTOSAVE_CONFIG = CHEMKIT_AUTOSAVE_CONFIG_WINDOW_KEY;
export const WINDOW_KEY_AUTOSAVE_RUNTIME = CHEMKIT_AUTOSAVE_RUNTIME_WINDOW_KEY;

// Event names
export const EVENT_ADDON_WAKE = addonLifecycle.ADDON_WAKE_EVENT;

// Source tags
export const SOURCE_UI_TABS_REFRESH = CHEMKIT_UI_TABS_REFRESH_SOURCE;
